import React from 'react'
import { connect } from 'react-redux'
import {
  CompanyId,
  DeleteTeams$Request,
  DivisionCategoryId,
  DivisionId,
  DivisionRow,
} from '../../../../services/api.types'
import { deleteTeams } from '../../store/TeamManagementActions'
import { getDeleteTeamsLoading } from '../../store/TeamManagementSelectors'
import { IGlobalState } from '../../../../Root/store/appReducer'
import DeleteTeams from './DeleteTeams'

interface DeleteTeamsWrapperProps {
  open: boolean
  onClose: () => void
  companyId: CompanyId
  companyTeams: DivisionDto[]
  teamsToDelete: DivisionId[]
  categoryId?: DivisionCategoryId
}

interface DeleteTeamsWrapperDispatchProps {
  deleteTeams: (payload: DeleteTeams$Request) => void
}

interface DeleteTeamsWrapperStateProps {
  loading: boolean
}

const mapStateToProps = (state: IGlobalState): DeleteTeamsWrapperStateProps => ({
  loading: !!getDeleteTeamsLoading(state),
})

const mapDispatchToProps: DeleteTeamsWrapperDispatchProps = {
  deleteTeams,
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)((props: DeleteTeamsWrapperProps & DeleteTeamsWrapperDispatchProps & DeleteTeamsWrapperStateProps) => {
  const { deleteTeams, loading, ...rest } = props

  const handleSubmit = (payload: DeleteTeams$Request) => {
    deleteTeams(payload)
  }

  return <DeleteTeams onSubmit={handleSubmit} loading={loading} {...rest} />
})
